import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mode", "links", "purposes", "row", "add", "empty", "enabled"]

  connect() {
    this.revealInvalidField = event => {
      const row = event.target.closest("details")
      if (!row) return
      this.modeTarget.value = "purposes"
      this.refresh()
      row.open = true
    }
    this.element.addEventListener("invalid", this.revealInvalidField, true)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("invalid", this.revealInvalidField, true)
  }

  refresh() {
    const purposes = this.modeTarget.value === "purposes"
    this.linksTarget.hidden = purposes
    this.purposesTarget.hidden = !purposes
    this.rowTargets.forEach(row => {
      const destination = row.querySelector("[data-purpose-destination]")
      const url = row.querySelector("[data-purpose-url]")
      const external = destination.value === "external"
      url.hidden = !external
      url.querySelector("input").disabled = !external
      const label = row.querySelector("[data-purpose-label-field]").value.trim() || "New choice"
      const description = row.querySelector("[data-purpose-description-field]").value.trim()
      row.querySelector("[data-purpose-label]").textContent = label
      row.querySelector("summary").setAttribute("aria-label", `Edit ${label}`)
      row.querySelector("[data-purpose-description]").textContent = description
      row.querySelector("[data-purpose-description]").hidden = !description
      row.querySelector("[data-purpose-summary]").textContent = external
        ? (url.querySelector("input").value.trim() || "Website URL")
        : destination.selectedOptions[0].textContent
    })
    this.addTarget.hidden = this.rowTargets.every(row => !row.hidden)
    this.emptyTarget.hidden = this.rowTargets.some(row => !row.hidden)
  }

  publish(event) {
    if (!this.element.reportValidity()) return
    this.enabledTarget.value = event.currentTarget.value
    this.element.requestSubmit()
  }

  add() {
    const row = this.rowTargets.find(row => row.hidden)
    if (!row) return
    row.hidden = false
    row.open = true
    this.refresh()
    row.querySelector("input").focus()
  }

  done(event) {
    const row = event.target.closest("details")
    row.open = false
    row.querySelector("summary").focus()
  }

  remove(event) {
    const row = event.target.closest("details")
    row.querySelectorAll("input, select").forEach(field => { field.value = "" })
    row.open = false
    row.hidden = true
    this.refresh()
    this.addTarget.focus()
  }
}
